import styled from "styled-components";
import { LoginContainer } from "../../../../styles/Login/Login";

const ValidateLoginContainer = styled(LoginContainer)`
    .top {
        .hide {
            display: none;
        }
        .infinite-path {
            width: 100%;
            max-width: 100%;
            @keyframes ani {
                0% {
                    left: -70px;
                }

                50% {
                    left: 370px;
                }

                100% {
                    left: -70px;
                }
            }

            @-webkit-keyframes ani {
                0% {
                    left: -70px;
                }

                50% {
                    left: 370px;
                }

                100% {
                    left: -70px;
                }
            }
        }
    }
`;

const Subheading = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: #979797;
    margin-bottom: 18px;
    .bold-txt {
        font-weight: bold;
        color: black;
    }
`;

const KudaAction = styled.div`
    background: #ffffff;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    min-height: 72px;
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 12px 24px;
    margin-bottom: 12px;
    gap: 22px;

    .login__otp-text-wrap {
        width: calc(100% - 54px);
    }

    .action-title {
        font-style: normal;
        font-weight: 900;
        font-size: 15px;
        line-height: 20px;
        color: #121212;
        margin-bottom: 1px;
    }
    .action-subtitle-login {
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 15px;
        color: #979797;
        max-width: 90%;
        white-space: nowrap;

        @media (max-width: 440px) {
            white-space: normal;
        }
    }
    .action-subtitle {
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 15px;
        color: #979797;
        max-width: 90%;
        /* white-space: nowrap; */

        @media (max-width: 440px) {
            white-space: normal;
        }
    }
`;

export const IconWrap = styled.div`
    display: flex;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);
`;

const SmsValidationContent = styled.div`
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .sub-heading-text {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        color: #979797;
        .bold-txt {
            color: black;
            font-weight: 800;
        }
    }
    .resend-txt {
        display: flex;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        color: #000000;
        margin: 20px 0px 40px;
        .green-txt {
            color: #48d38a;
        }
    }
    .next-btn {
        width: 117px;
        height: 38px;
        background: #000000;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 25px;
    }
    .width-wide {
        width: auto !important;
        max-width: 100% !important;
    }
    .approval-txt {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        padding-top: 35px;
        color: black;
        text-align: center;
        max-width: 80%;
        margin: auto;
        .bold-txt {
            color: black;
            font-weight: 800;
        }
    }
    .confirm-otp--form .transaction-pin input {
        max-width: 46px !important;
        background: #fff;
        border: 1px solid #f4f4f4;
        box-shadow: 0 2px 2px rgb(0 0 0 / 10%);
        border-radius: 5px;
    }
`;

const BigCardWrap = styled.div`
    background: #ffffff;
    margin: 100px 20px;
    padding: 0;

    @media screen and (min-width: 768px) {
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
        border-radius: 6px;
        max-width: 630px;
        min-height: 880px;
        padding: 52px 25px;
        margin: auto;
        margin-top: 100px;
    }

    @media screen and (min-width: 996px) {
        max-width: 840px;
    }

    @media screen and (min-width: 768px) {
        &.h-556 {
            min-height: 500px;
        }
        &.spacing-bottom {
            padding-bottom: 90px;
            min-height: unset;
        }
    }
`;

const VerifyPage = styled.div`
    margin-top: 134px;

    .resend-txt {
        font-size: 13px;
        line-height: 18px;
        color: #000000;
        max-width: 268px;
        width: 100%;

        .green-txt {
            color: #48d38a;
        }
    }

    .login-card--wrap {
        max-width: 408px;
        width: 100%;
        padding: 40px 20px 20px;

        @media screen and (min-width: 768px) {
            padding: 40px;
        }
    }

    .confirm-otp--form .transaction-pin {
        margin: 40px auto 24px;
        max-width: unset !important;
        > div {
            margin: 0 auto;
        }

        &.no-margin {
            margin-bottom: 20px !important;
        }
    }

    &.modal {
        .modal-content {
            padding: 40px;
            max-width: 415px;
        }
    }
`;

export {
    ValidateLoginContainer,
    Subheading,
    KudaAction,
    SmsValidationContent,
    BigCardWrap,
    VerifyPage,
};
